import { useState, useEffect } from "react";
import { Col, Row, Alert } from "react-bootstrap";
import astroimg from "../assets/img/astro.png";
import reactimg from "../assets/img/react-logo.png";
import coastal from "../assets/img/node.png";
import snapg from "../assets/img/snapgreetlogo.png";
import lightroom from "../assets/img/figma.png";
import canva from "../assets/img/Canva_icon_2021.svg.png";

const LogoData = [
  { img: astroimg },
  { img: reactimg },
  { img: coastal },
  { img: snapg },
  { img: lightroom },
  { img: canva },
];

export default function Adlogo() {
  return (
    <>
      <Col lg={12}>
        <div className="newsletter-bx wow slideInUp">
          {" "}
          <Row>
            <>
              {LogoData.map((data) => (
                <div className="col-md-2 col-sm-2 col-xs-2">
                  <img src={data.img} className="img-fluid" />
                </div>
              ))}
            </>
          </Row>
        </div>
      </Col>
    </>
  );
}
